import { getAvailableVariants } from './storefrontStock';
import { priceSummary } from './storefrontVariants';
export const filterValues = (filters, key, legacy) => filters[key]?.length ? filters[key] : filters[legacy] ? [filters[legacy]] : [];
export function productPrice(product) {
  const available = getAvailableVariants(product);
  const summary = priceSummary(available.length ? available : product.variants || []);
  return Number(summary.variant ? summary.price : product.price ?? 0);
}
export function productDiscount(product) {
  const available = getAvailableVariants(product);
  const summary = priceSummary(available.length ? available : product.variants || []);
  const mrp = Number(summary.variant?.mrp || product.mrp || 0);
  const price = productPrice(product);
  return mrp > 0 ? Math.max(0, (mrp - price) * 100 / mrp) : 0;
}
export function applyStorefrontFilters(products, filters, omit = '') {
  return products.filter(product => {
    const category = product.categoryDisplay || product.category;
    const categoryIds = filterValues(filters, 'categoryIds', 'categoryId');
    const subIds = filters.subCategoryIds || [];
    const brands = filterValues(filters, 'brands', 'brand');
    const sizes = filterValues(filters, 'sizes', 'size');
    const colors = filterValues(filters, 'colors', 'color');
    if (omit !== 'categoryIds' && categoryIds.length && !categoryIds.includes(category?.id)) return false;
    if (omit !== 'subCategoryIds' && subIds.length && !subIds.includes(product.subCategory?.id)) return false;
    if (omit !== 'subCategoryIds' && filters.subCategorySlug && product.subCategory?.slug !== filters.subCategorySlug) return false;
    if (omit !== 'brands' && brands.length && !brands.includes(product.brand?.name || product.brand)) return false;
    const price = productPrice(product);
    if (omit !== 'price' && ((filters.minPrice !== '' && filters.minPrice != null && price < Number(filters.minPrice)) || (filters.maxPrice !== '' && filters.maxPrice != null && price > Number(filters.maxPrice)))) return false;
    if (omit !== 'discount' && Number(filters.discount || 0) > productDiscount(product) + 1e-8) return false;
    if (filters.rating && Number(product.rating || 0) < Number(filters.rating)) return false;
    const selectedSizes = omit === 'sizes' ? [] : sizes;
    const selectedColors = omit === 'colors' ? [] : colors;
    if (selectedSizes.length || selectedColors.length) {
      const available = getAvailableVariants(product);
      const variants = available.length ? available : product.variants || [];
      if (!variants.some(variant => (!selectedSizes.length || selectedSizes.includes(variant.size?.name || variant.size?.code)) && (!selectedColors.length || selectedColors.includes(variant.color?.name)))) return false;
    }
    return true;
  });
}
export function activeStorefrontFilters(filters) {
  return ['categoryIds','subCategoryIds','brands','sizes','colors'].reduce((sum,key)=>sum+(filters[key]?.length||0),0)
    + ['categoryId','subCategorySlug','brand','size','color','minPrice','maxPrice','discount','rating'].filter(key=>filters[key] !== '' && filters[key] != null && filters[key] !== 0).length;
}
